import { Marker } from 'react-leaflet';
import L, { LeafletMouseEvent } from 'leaflet';
import { LargeInfoBoxTooltip } from '../ToolTips/LargeInfoBoxTooltip';
import SmallInfoBoxTooltip from '../ToolTips/SmallInfoBoxTooltip';
import useDevice from 'hooks/useDevice';
import { useMapStore, useRootStore } from 'contexts/RootStore.context';
import { Asset } from 'types/asset';
import useMap from 'views/map/hooks/useMap';
import { observer } from 'mobx-react';
import { getIconFromEstimateFreshness } from 'views/map/utils/utils';
import { AssetFlyout } from 'views/assets/AssetFlyout/AssetFlyout';

export const AssetMarker = observer(({ asset }: { asset: Asset }) => {
  const { freshPeriodThresholdSeconds } = useRootStore()
  const { filterForm, selectBeacon, selectedBeaconId, loadAssets } = useMapStore()
  const { panToLatLong } = useMap(useMapStore());
  const { isMobileDevice } = useDevice();

  const showMarkerLargeInfoBox = selectedBeaconId === asset.assigned_beacon!.id;

  const markerLong = asset.location.coordinates.longitude;
  const markerLat = asset.location.coordinates.latitude;

  function handleMarkerClick(e: LeafletMouseEvent, asset: Asset) {
    selectBeacon(asset.assigned_beacon!.id);
    panToLatLong(e.latlng);
  }

  const customIcon = new L.Icon({
    iconUrl: getIconFromEstimateFreshness(asset, freshPeriodThresholdSeconds),
    iconSize: new L.Point(20, 20),
    iconAnchor: [10, 10], // half of icon size.
    className: 'leaflet-custom-icon',
  });

  function handleCloseInfoBox() {
    selectBeacon(null);
  }

  return (
    <Marker
      title={`asset-marker-${asset.asset_id}`}
      eventHandlers={{
        click: (e) => {
          handleMarkerClick(e, asset);
        },
      }}
      icon={customIcon}
      position={[markerLat, markerLong]}
    >
      {showMarkerLargeInfoBox && !isMobileDevice && (
        <LargeInfoBoxTooltip asset={asset} handleCloseInfoBox={handleCloseInfoBox} />
      )}
      {showMarkerLargeInfoBox && isMobileDevice && (
        <AssetFlyout asset={asset} onClose={handleCloseInfoBox} hideAssetActivity onStatusUpdate={loadAssets} />
      )}
      {filterForm.$.displayAssetName.value && !showMarkerLargeInfoBox &&
        <SmallInfoBoxTooltip asset={asset} />}
    </Marker>
  );
})
